// How-to-Play content for the STANDARD / NORMAL layout.
//
// One shared six-step crash walkthrough (mechanics are identical across games).
// Only three things swap per game: the accent colour (handled entirely by the
// palette token `--standard-normal-app-how-to-play-accent-color`), the animated
// game object shown while the multiplier climbs, and the "what busts you" step.
//
// `family` drives which interactive visual renders (see ./visuals):
//   football → Defender   |   cricket → Howzzat   |   rocket → Crash / Rocket Boom

const GAME_FAMILY = {
  DEFENDER: 'football',
  HOWZZAT: 'cricket',
  CRASH: 'rocket',
  ROCKET_BOOM: 'rocket',
}

// Themed step 5 — the moment you lose if you haven't cashed out.
const BUST_STEP = {
  football: {
    heading: 'Beat the defender',
    body: 'If the defense concedes — a goal goes in — before you cash out, the round’s stake is gone. Timing is everything.',
  },
  cricket: {
    heading: 'Beat the bowler',
    body: 'If your wicket falls before you cash out, the round’s stake is gone. Read the play and time your shot.',
  },
  rocket: {
    heading: 'Beat the blast',
    body: 'If the rocket explodes before you cash out, the round’s stake is gone. Don’t push your luck too far.',
  },
}

const buildSteps = (family) => [
  {
    no: 1,
    visual: 'STAKE',
    heading: 'Choose your stake',
    body: 'Set how much to bet this round — tap a quick-stake chip or type your own amount.',
  },
  {
    no: 2,
    visual: 'BET',
    heading: 'Place your bet',
    body: 'Lock it in before the round starts. Switch on Auto Bet to stake the same amount automatically every round.',
  },
  {
    no: 3,
    visual: 'CLIMB',
    heading: 'Watch the multiplier climb',
    body: 'When the round goes live the multiplier keeps rising. The longer you hold your nerve, the bigger the potential win.',
  },
  {
    no: 4,
    visual: 'CASHOUT',
    heading: 'Cash out to win',
    body: 'Cash out any time to bank your stake × the current multiplier. Set an Auto Cashout target to lock in the instant it’s hit.',
  },
  {
    no: 5,
    visual: 'BUST',
    ...BUST_STEP[family],
  },
  {
    no: 6,
    visual: 'WIN',
    heading: 'Win big',
    body: 'Cash out at the right moment to win up to 150× your stake. Every round is provably fair — verify any result from your bet history.',
  },
]

export const resolveHowToPlaySteps = (gameCode) => {
  const family = GAME_FAMILY[String(gameCode || '').toUpperCase()] ?? 'rocket'
  return { family, steps: buildSteps(family) }
}
